<template>
  <div>
    <loader v-if="loader"
            color="white" />
    <v-server-table
        ref="transactions"
        :url="url"
        :columns="columns"
        :options="options"
        class="transactions-history-table"
        @loaded="onTableLoaded"
        @loading="loader = true">
      <template slot="invoice_number" slot-scope="props">
        <span>{{props.row.invoice_number}}</span>
      </template>

      <template slot="amount" slot-scope="props">
        <cents-to-bills :row="props.row" column="amount" :currency="true"/>
      </template>

      <template slot="created_at" slot-scope="props">
        <column-date :row="props.row" column="created_at" format="L"/>
      </template>

      <template slot="status" slot-scope="props">
        <b-badge variant="success" v-if="props.row.status === 'paid'">
          {{props.row.status}}
        </b-badge>
        <b-badge variant="danger" v-else>{{props.row.status}}</b-badge>
      </template>

      <template slot="amount" slot-scope="props">
        <cents-to-bills :row="props.row" column="amount" :currency-symbol="true"/>
      </template>

      <template slot="actions" slot-scope="props">
        <column-action
            v-if="props.row.pay_system === 'manual'"
            :deleteUrl="`/transactions/${props.row.id}`"
            :route="{path: `/transactions/edit/${props.row.id}`, params: props.row}"
            :showEditButton="false"
            @deleteItems="refreshTable('transactions')"/>
      </template>
    </v-server-table>
  </div>
</template>

<script>
import i18n from "../../utils/i18n";
import axios from "@/utils/axios";

export default {
  name: "BillingTransactionHistory",
  props: {
    resourceKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      loader: false,
      isTableEmpty: false,
      options: {
        skin: [],
        columnsClasses: {
          actions: 'column-narrow'
        },
        headings: {
          invoice_number: '#',
          pay_system: i18n.t('transactions.payment_system'),
          amount: i18n.t('transactions.amount'),
          created_at: i18n.t('transactions.date_&_time'),
          status: i18n.t('form.status'),
          actions: i18n.t('global.actions')
        },
        sortable: [],
        dateColumns: ['created_at'],
        columnsDropdown: false,
        filterByColumn: false,
        customFilters: ['custom'],
        filterable: false,
        requestFunction: function (data) {
          return axios.get(this.url).catch((e) => {
            // this.$noty.error(e.error_description);
            this.dispatch('error', e);
          });
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp);

          return {
            data: data.data.items,
            count: data.data.paginator.total_items
          }
        }
      },
      columns: ['invoice_number', 'amount', 'created_at', 'status'],
    }
  },
  methods: {
    onTableLoaded(data) {
      this.isTableEmpty = !(data.data && Array.isArray(data.data.items) && data.data.items.length);
      this.loaded = true;
      this.loader = false;
      this.$emit('table-empty', this.isTableEmpty);
    }
  },
  computed: {
    url() {
      return `/admin/resources/${this.resourceKey}/pricing/invoices/transactions`;
    }
  }
}
</script>